/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateOrgSubscriptionStripeRecurrenceEnum = "Monthly" | "Yearly" | "%future added value";
export type CreateOrgSubscriptionStripeInput = {
    clientMutationId?: string | null | undefined;
    initialUsers: Array<string>;
    numSeats?: number | null | undefined;
    orgRelayId: string;
    recurrence: CreateOrgSubscriptionStripeRecurrenceEnum;
    stripePaymentMethodId: string;
};
export type CreateOrgSubscriptionStripeMutationVariables = {
    input: CreateOrgSubscriptionStripeInput;
};
export type CreateOrgSubscriptionStripeMutationResponse = {
    readonly createOrgSubscriptionStripe: {
        readonly clientMutationId: string | null;
        readonly stripeError: {
            readonly code: string | null;
            readonly message: string | null;
        } | null;
    } | null;
};
export type CreateOrgSubscriptionStripeMutation = {
    readonly response: CreateOrgSubscriptionStripeMutationResponse;
    readonly variables: CreateOrgSubscriptionStripeMutationVariables;
};



/*
mutation CreateOrgSubscriptionStripeMutation(
  $input: CreateOrgSubscriptionStripeInput!
) {
  createOrgSubscriptionStripe(input: $input) {
    clientMutationId
    stripeError {
      code
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateOrgSubscriptionStripePayload",
            "kind": "LinkedField",
            "name": "createOrgSubscriptionStripe",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "StripeError",
                    "kind": "LinkedField",
                    "name": "stripeError",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateOrgSubscriptionStripeMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CreateOrgSubscriptionStripeMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "15af9a4ad6bbdc0992df5f1beac91459",
            "id": null,
            "metadata": {},
            "name": "CreateOrgSubscriptionStripeMutation",
            "operationKind": "mutation",
            "text": "mutation CreateOrgSubscriptionStripeMutation(\n  $input: CreateOrgSubscriptionStripeInput!\n) {\n  createOrgSubscriptionStripe(input: $input) {\n    clientMutationId\n    stripeError {\n      code\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '746b972132a331019cddaf0dd3ff4d62';
export default node;
